import React, { Component } from 'react'
import BigCalendar from 'react-big-calendar';
import Modal from 'react-modal';
import Alert from 'react-s-alert';
import firebase from 'firebase';
import InfiniteCalendar, { Calendar, defaultMultipleDateInterpolation, withMultipleDates } from 'react-infinite-calendar';
import 'react-infinite-calendar/styles.css';
import './estilo.css'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'moment/locale/es';
import store from '../../store';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import moment from 'moment';
//use material theme
import 'react-times/css/material/default.css';
import Select from 'react-select';
import icon from '../../img/Group.png'
import { Pulse } from 'react-preloading-component';
import copyright from '../../img/copyright-gray.png';
import vehiculoSVG from '../../img/vehi.svg'
import driverSVG from '../../img/driver.svg'
import { sendLog } from '../../util'

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment))
const format = 'h:mm a';
let seleccionadosGuardados = [];
const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		transform: 'translate(-50%, -50%)',
		width: '85%',
		height: '500px',

	}
};
const customStylesS = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		transform: 'translate(-50%, -50%)',
		width: '700px',
		height: '350px',

	}
};
const customStylesM = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		transform: 'translate(-50%, -50%)',
		width: '80%',
		height: '550px',

	}
};

var today = new Date();
class NuevoViaje extends Component {
	constructor(props) {
		super(props);
		this.state = {
			viaje: [],
			ruta: [],
			filtro: { label: 'Todos', value: 'Todos' },
			template: false, eventos: [], seleccionados: [], vuelo: '', isGuardando: true, empresas: [], empresa: '',
			tipo: 'tcs', actual: '', empresaUID: '', isActive: false, isActiveSeleccion: false, userKey: '',
			isActiveCarga: false, isActiveModificar: false, edt2: '', viajes: [], viajesD: [], select: false,
			isElimi: false, isGuar: false, actualV: [], generales: [], justiCanc: '', seleElim: [],
			pasado: 0, empleadosEmpresa: [], justiAdd: '', empleS: '', hour: moment().format('HH'), minute: moment().format('mm'),
			hour2: moment().format('HH'), minute2: moment().format('mm'), value: 'pilotos', bases: [], baseI: '', baseF: '', basesF: [],
			HI: '', inicio: '', destino: '', estado: '', rutas: [], rutaA: '', now: moment(), now2: moment(),
			rutasS: [], programacionDiaKey: [], pasajeros: [], isLoading: true, prograID: '', prograDiaId: '',
			actual: [], guardados: [], busqueda: [], centroCosto: [], centro: '', flotas: [], flota: [], entrenamiento: 'inicial',
			viajesDAux: [], pasajerosArr: [], isSaving: false, isModalOpen: false, conductores: [], filteredConductores: [], vehiculos: [], vehiculo: '', conductor: '',
			colaProgramacionDia: [], fechaInicio: '', fechaFin: '', disabledDays: [], nombreViaje: ''
		};
		this.AlertaContenido = ({
			id,
			classNames,
			styles,
			message,
			customFields,
			handleClose,
		}) => {
			const handleConfirm = () => {
				this.almacenarCambios()
				Alert.close(id);
				this.setState({
					template: false
				})
			}
			return (
				<div className={classNames} id={id} style={styles}>
					<div className='s-alert-box-inner'>
						{message}
					</div>
					<br />
					<br />
					<button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
					<button className="customButton btn btn-default btn-alerts btn-m-r" onClick={handleClose}>Cancelar</button>
					<span className='s-alert-close' onClick={handleClose}></span>
				</div>
			);
		}
		// this.empresasUID = this.empresasUID.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleChangeE = this.handleChangeE.bind(this);
		this.cargar = this.cargar.bind(this);
		this.modificar = this.modificar.bind(this);
		this.isELi = this.isELi.bind(this);
		this.justi = this.justi.bind(this);
		this.cancela = this.cancela.bind(this);
		this.marcar = this.marcar.bind(this);
		this.nuevoPas = this.nuevoPas.bind(this);
		this.addEmple = this.addEmple.bind(this);
		this.obtenerEmpresas = this.obtenerEmpresas.bind(this);
		this.getEmpresas = this.getEmpresas.bind(this);
		this.vuelo = null;
	}

	ocultarMenu() {
		store.dispatch({
			type: 'STATE_MOSTRAR',
			mostrar: 'noMostrar'
		})
	}

	async getViaje() {
		firebase.database().ref('TiposViajes').on('value', snap => {
			let viaje = [];
			let o = { label: 'Todas las rutas', value: 'Todos' };
			viaje.push(o);
			snap.forEach(element => {
				let obje = element.val();
				o = { label: obje.nombre, value: element.key };
				viaje.push(o);
			});
			this.setState({ viaje });
		})
	}

	selectViaje(filtro) {
		this.setState({ rutaA: ' ', filtro });
	}

	filterRutas() {
		return this.state.filtro.value === 'Todos' ? this.state.rutas : this.state.rutas.filter(ruta => '' + ruta.tipoViaje === this.state.filtro.value);
	}

	getEmpresas() {
		firebase.database().ref("Empresa").once("value", snap => {
			let oempresas = [];
			snap.forEach(element => {
				oempresas.push({
					value: element.key,
					label: element.val().codigo_empresa
				});
			});
			this.setState({ empresas: oempresas });
		});
	}

	obtenerEmpresas() {
		let self = this;
		let oempresas = [];
		let empresaU = '';
		firebase.database().ref('Empresa').once('value', snap => {
			snap.forEach(element => {
				oempresas.push({
					value: element.key,
					label: element.val().codigo_empresa
				});
			});
		}).then(snap => {
			let key = firebase.auth().currentUser.uid;
			self.setState({ userKey: key, empresas: oempresas });
			empresaU = self.getEmpresa();

			self.setState({ empresaUID: empresaU });
			let nempresa = self.getNombreEmpresa();
			self.setState({ empresa: nempresa });
			firebase.database().ref('AjustesEmpresa/' + self.state.empresaUID + '/tiposV').once('value').then(snap => {
				let data = snap.val();
				self.setState({ viajes: data })
			});

			self.getBases();
			self.getRutas(empresaU);
			self.getClientes(empresaU);
			self.getFlotas();
		});
	}

	changeEmpresa = (event) => {
		/* Refresco de eventos */
		this.setState({ empresaUID: event.value, empresa: event, isLoading: true });
		firebase.database().ref('AjustesEmpresa/' + event.value + '/tiposV').once('value').then(snap => {
			let data = snap.val();
			this.setState({ viajes: data })
		});
		this.getBases();
		this.getRutas(event.value);
		this.getClientes(event.value);
		this.getFlotas();
	}

	getNombreEmpresa() {
		let { empresas, empresaUID } = this.state;
		let e = empresas.find(v => v.value == empresaUID);
		return e;
	}

	getEmpresa() {
		let { empresas, userKey } = this.state;
		let e;
		function findValue(empresa) {
			return empresa.value === userKey;
		}
		try {
			e = empresas.find(findValue).value;
			this.setState({ empresa: e.codigo_empresa });
		} catch (error) {
			e = empresas[0].value;
			this.setState({ empresa: empresas[0].codigo_empresa });
		}
		return e;
	}

	getRutas() {
		firebase.database().ref('TiposViajes').once('value').then(snap => {
			let tiposViajes = [];
			let o = [];
			snap.forEach(element => {
				let o = element.val();
				o.key = element.key;
				tiposViajes.push(o);
			});
			this.setState({ tiposViajes });
		})
	}

	getRutas(empresaUID) {
		firebase.database().ref('Rutas').once('value').then(snap => {
			let rutas = [];
			let rutasS = [];
			let o = [];
			snap.forEach(element => {
				let obje = element.val();
				obje.key = element.key;
				o = { label: obje.nombRuta, value: element.key, tipoViaje: element.val().tipoViaje };
				rutas.push(o);
				rutasS.push(obje);
			});
			this.setState({ rutas, rutasS });
			this.getProgra(empresaUID);
		})
	}

	componentDidMount = () => {
		Modal.setAppElement('body');
		this.obtenerEmpresas();
		this.getConductoresVehiculos();
		this.getViaje();
	}

	getConductoresVehiculos = async () => {
		const snapConductores = await firebase.database().ref('/Empleados').once('value');
		const snapVehiculos = await firebase.database().ref('/Vehiculos').once('value');
		const conductores = [];
		const vehiculos = [];

		let data = snapConductores.val();
		for (const key in data) {
			if (key != 'undefined') {
				data[key].key = key;
				conductores.push(data[key]);
			}
		}

		data = snapVehiculos.val();
		for (const key in data) {
			if (typeof data[key] == 'object') {
				data[key].key = key;
				vehiculos.push(data[key]);
			}
		}

		this.setState({ conductores, vehiculos, filteredConductores: conductores });
	}

	getClientes = (empresaUID) => {

		firebase.database().ref().child('Clientes').orderByChild('socio').equalTo(empresaUID).once('value').then(snap => {
			let empleadosEmpresa = [];
			let pasajeros = [];
			snap.forEach(element => {
				let data = element.val();
				data.key = element.key;
				let emple = { 
					value: element.key, 
					label: data.nombre + ' ' + data.apellido, 
					escalafon: data.escalafon, 
					codigo: data.numero_empleado,
					centroCosto: data.centro,
					areaUsuaria: data.areaDesc,
					coordenadas : data.coordenadas || '',
				};
				if (data.estado == 'Activo') {
					empleadosEmpresa.push(emple);
					pasajeros.push(emple);
				}
			});
			let centroCosto = [];
			firebase.database().ref().child('CentroCosto').orderByChild('empresa').equalTo(empresaUID).once('value').then(snapC => {
				snapC.forEach(element => {
					let data = element.val();
					if (data.estado !== undefined && data.estado === 'Operativo') {
						let emple = { value: element.key, label: data.codigo };
						centroCosto.push(emple);
					}

				});
			})
			this.setState({ empleadosEmpresa, isLoading: false, pasajeros, centroCosto })
		})
	}

	selectValidate = () => {
		this.setState({ entrenamiento: '', flota: [] })
	}

	componentWillUnmount = () => {
		let { empresaUID } = this.state;
		firebase.database().ref().child('Programacion').orderByChild('solicitante').equalTo(empresaUID).off();
	}

	getProgra = (empresaUID, handle = null) => {
		firebase.database().ref().child('Programacion').orderByChild('solicitante').equalTo(empresaUID).once('value').then(snap => {
			let arrayT = [];
			snap.forEach((element) => {
				let obte = element.val();
				let hora = obte.horaReco.split(":");
				if (Array.isArray(obte.frecuencia)) {
					obte.frecuencia.map(f => {
						let fecha = new Date(f);
						let fechaActu = new Date();
						let fechaCom = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), hora[0], hora[1]);
						let fechaComA = new Date(fechaActu.getFullYear(), fechaActu.getMonth(), fechaActu.getDate(), fechaActu.getHours());
						if (fechaCom.getTime() >= fechaComA.getTime())
							arrayT.push({
								id: element.key,
								title: obte.vuelo,
								start: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), hora[0], hora[1]),
								end: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), hora[0], hora[1]),
								desc: obte.tipo,
							})
					});
				}
			});
			this.setState({ eventos: arrayT });
			if (handle === null) {
				this.toggleActive();
			}
		})
	}

	getBases = () => {
		firebase.database().ref('Bases').once('value').then(snap => {
			let bases = [];
			snap.forEach(element => {
				let data = element.val();
				data.key = element.key;
				bases.push(data);
			});
			this.setState({ bases });
		})
	}

	validar = (edt2) => {
		this.setState({ isActiveSeleccion: true })
		let { empleadosEmpresa, pasajeros } = this.state;
		firebase.database().ref().child('ProgramacionDia').orderByChild('programacion').equalTo(edt2.id).once('value').then(snap => {
			if (snap.val() !== null) {
				snap.forEach(element => {
					let data = element.val();
					let fechaSeleccionada = new Date(edt2.start);
					let fechaSeleccionadaBuena = new Date(fechaSeleccionada.getFullYear() + '/' + (fechaSeleccionada.getMonth() + 1) + '/' + fechaSeleccionada.getDate());
					let fechaRegistro = new Date(data.fecha);
					if (fechaSeleccionadaBuena.getTime() === fechaRegistro.getTime()) {
						if (data.pasajeros !== undefined) {
							this.setState({ viajesD: data.pasajeros, prograDiaId: element.key, actual: data });
						}
						else {
							this.setState({ viajesD: [], empleadosEmpresa: pasajeros, prograDiaId: element.key, actual: data })
						}
					}
				});
				this.setState({ prograID: edt2, isGuardando: false, busqueda: snap })
			}
			else {
				this.setState({ prograID: edt2, isGuardando: false, })
			}
		})
	}

	toggleActive = () => {
		Alert.close();
		this.setState({ now: moment(), now2: moment(), isActive: false, isSaving: false, isActiveModificar: false })
	}
	toggleActiveS = () => {
		this.setState({ isActiveSeleccion: false })
	}
	toggleActiveC = () => {
		this.setState({ isActiveCarga: false })
	}
	toggleActiveM = () => {
		this.setState({ isActiveModificar: false, pasajerosArr: [] })
	}

	nuevaRese = (datos) => {
		let objetos = []
		datos.slots.forEach(element => {
			objetos.push(element);
		});
		seleccionadosGuardados = objetos;
		this.setState({
			seleccionados: objetos, isActive: true, isGuardando: true, vuelo: '', ruta: '', edt: '00:00', entrenamiento: ' ', centro: ' ', entrenamiento: ' ', flota: ' ',
			filtro: ' ', rutaA: ' ', hour: moment().format('HH'), minute: moment().format('mm'), hour2: moment().format('HH'), minute2: moment().format('mm')
		})
	}

	tipo = (event, start, end, isSelected) => {
		if (event.desc === 'pilotos') {
			let newStyle = {}; newStyle.backgroundColor = "#512B39"
			return { className: "", style: newStyle };
		}
		if (event.desc === 'pilotossap') {
			let newStyle = {}; newStyle.backgroundColor = "#A0A2A4"
			return { className: "", style: newStyle };
		}
		if (event.desc === 'tcs') {
			let newStyle = {}; newStyle.backgroundColor = "#DF2525"
			return { className: "", style: newStyle };
		}
		if (event.desc === 'tcssap') {
			let newStyle = {}; newStyle.backgroundColor = "#EC7536"
			return { className: "", style: newStyle };
		}
		if (event.desc === 'persTierr') {
			let newStyle = {}; newStyle.backgroundColor = "#333856"
			return { className: "", style: newStyle };
		}
	}

	selecion = (datos) => {
		let fecha = datos.toString();
		let found = seleccionadosGuardados.find(element => {
			return element.toString() == fecha.toString();
		});

		if (found === undefined) {
			seleccionadosGuardados = [...seleccionadosGuardados, fecha]
		} else {
			let obje = seleccionadosGuardados;
			let index = obje.indexOf(found);
			obje.splice(index, 1)

			seleccionadosGuardados = [...obje];
			this.setState({ seleccionados: [...obje] });
		}

		let fechasString = seleccionadosGuardados.map((item, i) => moment(item).format()).filter((val, i) => moment(val).isAfter(moment(new Date()).subtract(1, 'days')))
		fechasString = fechasString.map(item => moment(item).format('YYYY-MM-DD'));

		let disabledDates = this.state.disabledDays.map(item => moment(item).format('YYYY-MM-DD'));
		fechasString = fechasString.filter(item => !disabledDates.includes(item));

		const fechaInicio = moment.min(fechasString.map(item => moment(item))).format('DD/MM/YYYY');
		const fechaFin = moment.max(fechasString.map(item => moment(item))).format('DD/MM/YYYY');

		this.setState({ fechaInicio, fechaFin });
	}

	guardarReserva = (event) => {
		this.setState({
			template: true
		})
		const customerName = 'Bacer';
		Alert.success('¿Deseas confirmar los cambios?', {
			position: 'top-right',
			timeout: 'none',
			customFields: {
				customerName: customerName
			}
		});

		event.preventDefault();
	}

	getFlotas() {
		firebase.database().ref('Flotas').once('value').then(snap => {
			let flotas = [];
			snap.forEach(element => {
				let data = element.val();

				flotas.push({ label: data.flota, value: element.key });
			})
			this.setState({ flotas });

		})
	}

	addNewData = (frecuencia, key, datos) => {
		let arrayT = this.state.eventos;
		let hora = datos.horaReco.split(":");
		frecuencia.map(f => {
			let fecha = new Date(f);
			let fechaActu = new Date();
			let fechaCom = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), hora[0], hora[1]);
			let fechaComA = new Date(fechaActu.getFullYear(), fechaActu.getMonth(), fechaActu.getDate(), fechaActu.getHours());
			if (fechaCom.getTime() >= fechaComA.getTime())
				arrayT.push({
					id: key,
					title: datos.vuelo,
					start: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), hora[0], hora[1]),
					end: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), hora[0], hora[1]),
					desc: datos.tipo,
				})
		});
		this.setState({ eventos: arrayT });
		this.toggleActive();
	}

	updateExistingData = (frecuencia, key, datos) => {
		let arrayT = this.state.eventos;
		arrayT = arrayT.filter(snap => snap.id !== key)
		let hora = datos.horaReco.split(":");
		frecuencia.map(f => {
			let fecha = new Date(f);
			let fechaActu = new Date();
			let fechaCom = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), hora[0], hora[1]);
			let fechaComA = new Date(fechaActu.getFullYear(), fechaActu.getMonth(), fechaActu.getDate(), fechaActu.getHours());
			if (fechaCom.getTime() >= fechaComA.getTime())
				arrayT.push({
					id: key,
					title: datos.vuelo,
					start: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), hora[0], hora[1]),
					end: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), hora[0], hora[1]),
					desc: datos.tipo,
				})
		});
		this.setState({ eventos: arrayT, rutaA: [] });
		Alert.success('Datos Modificados', {
			effect: 'genie',
			position: 'bottom-right',
			timeout: 2000
		});
		this.toggleActive();
	}

	optimizarPrograDia = async (data) => {
		try {
			if (data.ruta && data.programacion) {
				const snapR = await firebase.database().ref('Rutas/' + data.ruta).once('value');
				const rutas = snapR.val();

				const snapP = await firebase.database().ref('Programacion/' + data.programacion).once('value');
				const programacion = snapP.val();

				const tiposViajes = await firebase.database().ref('TiposViajes/' + rutas.tipoViaje).once('value');
				const tipos = tiposViajes.val();

				delete rutas.georeferencia;
				delete programacion.programacionDia;
				delete programacion.frecuencia;

				data.rutaF = rutas;
				data.programacionF = programacion;
				data.tipoF = tipos;

			}
			return data

		} catch (error) {
			console.log('error in optimizarPrograDia:', error);
		}
	}

	almacenarCambios = async () => {
		let { seleccionados, guardados, busqueda, centro, flota, entrenamiento, select, empresaUID } = this.state;
		let dato = [];
		let usua = empresaUID;
		let ruta = this.state.rutaA.value;
		let tipo = this.state.value;
		let centroC = this.state.centro.value;
		flota = flota.value;
		let aliasProgramacion = this.vuelo.value.trim();

		if (aliasProgramacion) {
			if (ruta) {
				if (centroC) {
					if (flota || !select) {
						// if (entrenamiento) {
						this.setState({ isSaving: true });
						//Guardar
						if (this.state.isGuardando === true) {
							let datos = {
								tipo,
								estado: true,
								solicitante: usua,
								horaReco: this.state.hour + ':' + this.state.minute,
								horaAero: this.state.hour2 + ':' + this.state.minute2,
								vuelo: this.vuelo.value,
								frecuencia: '',
								ruta,
								centroC,
								flota: select ? flota : '',
								entrenamiento: select ? entrenamiento : ''
							}

							var hola = firebase.database().ref().child('Programacion').push({ ...datos });
							var messageRef = firebase.database().ref("Programacion/" + hola.key + "/frecuencia/");
							let v = [];
							let arreglo = [];
							let pD = {
								conductor: '',
								estado: 'Pendiente',
								horaInicio: this.state.hour + ':' + this.state.minute,
								horaLlegada: this.state.hour2 + ':' + this.state.minute2,
								programacion: hola.key,
								puntoA: 0,
								ruta,
								vehiculo: ''
							}

							let data = {
								...pD,
								centroC: centro.value
							};

							data = await this.optimizarPrograDia(data);

							seleccionadosGuardados.forEach(element => {
								v = [...v, element.toString()];
								arreglo.push(new Promise(async (resolve, reject) => {
									data.fecha = element.toString();
									const ref = firebase.database().ref("ProgramacionDia").push(data);

									resolve(ref.key)
								}))
							});
							Promise.all(arreglo).then(snap => {
								let valor = firebase.database().ref().child('Programacion').child(hola.key).update({ programacionDia: snap });
								messageRef.set(v);
								this.addNewData(v, hola.key, datos);
								this.setState({ now: moment(), now2: moment() })
								Alert.success('Datos Guardados', {
									effect: 'genie',
									position: 'bottom-right',
									timeout: 2000
								});
							})
							const dataArreglo = await Promise.all(arreglo);
							sendLog({ tipo: 'viaje_nuevo', informacion_extra: {programacion: hola.key}  });
						}

						//Modificar
						else {
							const { actual } = this.state;
							const nuevos = [];
							let data = {
								conductor: '',
								estado: 'Pendiente',
								horaInicio: this.state.hour + ':' + this.state.minute,
								horaLlegada: this.state.hour2 + ':' + this.state.minute2,
								programacion: actual.programacion,
								puntoA: 0,
								ruta,
								vehiculo: '',
							}

							data = await this.optimizarPrograDia(data);

							seleccionadosGuardados.forEach(element => {
								if (guardados.includes(element)) {
								} else {
									data.fecha = element.toString();
									firebase.database().ref().child('ProgramacionDia').push(data);

								}
							});

							guardados.forEach(element => {
								if (seleccionadosGuardados.includes(element)) {
									busqueda.forEach(async elementB => {
										let dato = elementB.val();
										let fechaSeleccionada = new Date(element);
										let fechaSeleccionadaBuena = new Date(fechaSeleccionada.getFullYear() + '/' + (fechaSeleccionada.getMonth() + 1) + '/' + fechaSeleccionada.getDate());
										let fechaRegistro = new Date(dato.fecha);


										if (fechaSeleccionadaBuena.getTime() === fechaRegistro.getTime()) {

											data.fecha = element.toString();
											firebase.database().ref().child('ProgramacionDia/' + elementB.key).update(data);
										}

									});
								} else {
									busqueda.forEach(elementB => {
										let data = elementB.val();
										let fechaSeleccionada = new Date(element);
										let fechaSeleccionadaBuena = new Date(fechaSeleccionada.getFullYear() + '/' + (fechaSeleccionada.getMonth() + 1) + '/' + fechaSeleccionada.getDate());
										let fechaRegistro = new Date(data.fecha);
										if (fechaSeleccionadaBuena.getTime() === fechaRegistro.getTime()) {
											firebase.database().ref().child('ProgramacionDia/' + elementB.key).update({
												estado: 'Inactivo'
											})
											if (data.conductor !== '') {
												firebase.database().ref().child('Empleados/' + data.conductor).update({
													viajeAsignado: false,
													espera: false
												})
											}
											if (data.vehiculo !== '') {
												firebase.database().ref().child('Vehiculos/' + data.vehiculo).update({
													estado: 'Disponible',
													viajeAsignado: false
												})
											}
										}
									});

								}
							});


							let { prograID } = this.state;
							let datos = {
								tipo,
								horaReco: this.state.hour + ':' + this.state.minute,
								horaAero: this.state.hour2 + ':' + this.state.minute2,
								vuelo: this.state.nombreViaje || this.state.vuelo,
								frecuencia: '',
								ruta,
								frecuencia: seleccionadosGuardados,
								centroC,
								flota: select ? flota : '',
								entrenamiento: select ? entrenamiento : ''
							}

							sendLog({ tipo: 'viaje_editado', informacion_extra: {programacion: prograID.id }});

							firebase.database().ref().child('Programacion/' + prograID.id).update({
								...datos
							});


							this.updateExistingData(seleccionadosGuardados, prograID.id, datos);
						}

						this.setState({ nombreViaje: '' });
						// }
						// else {
						// Alert.warning('Seleccione entrenamiento de pilotos para este viaje', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
						// }
					}
					else {
						Alert.warning('Seleccione flotas de pilotos para este viaje', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
					}
				}
				else {
					Alert.warning('Seleccione centros de costos para este viaje', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
				}

			}
			else {
				Alert.warning('Seleccione la ruta a programar para este viaje', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
			}
		} else {
			Alert.warning('Ingrese un nombre para este viaje', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
		}
	}

	handleChange(event) {
		this.setState({ entrenamiento: event.target.value });
	}

	handleChangeE = (event) => {
		if (event.target.value === 'pilotossap' || event.target.value === 'tcssap') {
			this.setState({ select: true });
			if (this.state.entrenamiento === '') {
				this.setState({ entrenamiento: 'inicial' });
			}
		}
		else {
			this.setState({ select: false });
			this.selectValidate();

		}
		this.setState({ value: event.target.value });
	}

	cargar() {
		this.setState({ isActiveCarga: true, isActiveSeleccion: false })
	}

	modificar() {
		this.setState({ isActiveSeleccion: false, isActiveModificar: true })
	}

	asignarCoductorVehiculo = async () => {
		let { prograID, rutas, centroCosto, flota, empresaUID } = this.state;
		const snap = await firebase.database().ref('Programacion/' + prograID.id).once('value');


		let seleccionados = [];
		let guardados = [];
		let objetos = snap.val();
		if (objetos) {
			objetos.frecuencia.forEach(element => {
				seleccionados.push(element);
				guardados.push(element)
			});
			let vuelo = objetos.vuelo;
			let rutaA = rutas.find(x => objetos.ruta === x.value);
			let centro = centroCosto.find(x => objetos.centroC === x.value);
			let time = objetos.horaReco.split(':');
			let time2 = objetos.horaAero.split(':');
			let now = moment().hour(Number(time[0])).minute(Number(time[1]))
			let now2 = moment().hour(Number(time2[0])).minute(Number(time2[1]))
			let value = objetos.tipo;
			let hour = Number(time[0])
			let minute = Number(time[1])
			let hour2 = Number(time2[0])
			let minute2 = Number(time2[1])
			let flotaD = objetos.flota;
			let entrenamiento = objetos.entrenamiento;

			if (value === 'pilotossap' || value === 'tcssap') {
				this.setState({ select: true });
				firebase.database().ref('Flotas/' + flotaD).once('value').then(data => {
					let element = data.val();
					if (element !== null && element !== undefined) {
						this.setState({ flota: { label: element.flota, value: flotaD } });
					}
				})
			} else {
				this.setState({ select: false });
				this.selectValidate();
			}


			seleccionadosGuardados = seleccionados;
			const fechas = seleccionados.map((item, i) => moment(item)).filter((val, i) => moment(val).isAfter(moment(new Date()).subtract(1, 'days')))
			let fechasString = seleccionados.map((item, i) => moment(item).format()).filter((val, i) => moment(val).isAfter(moment(new Date()).subtract(1, 'days')))
			const maxDate = moment.max(fechas).format();
			const minDate = moment.min(fechas).format();
			const cantidadDias = moment(maxDate).dayOfYear() - moment(minDate).dayOfYear() + 1;
			const allDays = [];


			for (let i = 0; i < cantidadDias; i++) {
				allDays.push(moment(minDate).add(i, 'd').format());
			}

			const disabledDays = allDays.filter((val, i) => {
				return !fechasString.includes(val);
			})


			const colaProgramacionDia = [];
			if (objetos.colaProgramacionDia) {
				const cola = objetos.colaProgramacionDia;


				for (const key in cola) {

					const fechasCola = [];
					if (cola[key].programacionDias) {
						for (const item of cola[key].programacionDias) {
							disabledDays.push(moment(item.fecha).format());
							fechasCola.push(item.fecha);
						}
					}

					const conductor = this.state.conductores.find(item => {
						return item.key == cola[key].conductor
					})

					const vehiculo = this.state.vehiculos.find(item => {
						return item.key == cola[key].vehiculo
					})

					const inicio = moment.min(fechasCola.map(item => moment(item))).format('DD/MM/YYYY');
					const fin = moment.max(fechasCola.map(item => moment(item))).format('DD/MM/YYYY');


					colaProgramacionDia.push({ conductor: conductor.nombre, vehiculo: `${vehiculo.movil} (${vehiculo.placa})`, inicio, fin });
				}
			}

			let fechasString2 = seleccionadosGuardados.map((item, i) => moment(item).format()).filter((val, i) => moment(val).isAfter(moment(new Date()).subtract(1, 'days')))
			fechasString2 = fechasString2.map(item => moment(item).format('YYYY-MM-DD'));

			let disabledDates = disabledDays.map(item => moment(item).format('YYYY-MM-DD'));
			fechasString2 = fechasString2.filter(item => !disabledDates.includes(item));

			const fechaInicio = moment.min(fechasString2.map(item => moment(item))).format('DD/MM/YYYY');
			const fechaFin = moment.max(fechasString2.map(item => moment(item))).format('DD/MM/YYYY');


			this.setState({
				seleccionados: fechasString, isActiveSeleccion: false, isModalOpen: true, vuelo, rutaA, now, now2, guardados, centro,
				value, hour, minute, hour2, minute2, entrenamiento, maxDate, minDate, disabledDays: disabledDates, colaProgramacionDia, conductor: '', vehiculo: '',
				fechaInicio, fechaFin
			})

		}
	}

	guardarAsignacionVehiculo = async () => {
		try {
			let { seleccionados, conductor, vehiculo, prograID, disabledDays } = this.state;

			let fechasString = seleccionadosGuardados.map((item, i) => moment(item).format()).filter((val, i) => moment(val).isAfter(moment(new Date()).subtract(1, 'days')))
			fechasString = fechasString.filter(item => !disabledDays.includes(moment(item).format('YYYY-MM-DD')));

			if (!conductor)
				Alert.warning('Seleccione un conductor', { effect: 'genie', position: 'bottom-right', timeout: 2000 });
			else if (!vehiculo)
				Alert.warning('Seleccione un vehiculo', { effect: 'genie', position: 'bottom-right', timeout: 2000 });
			else if (!fechasString.length)
				Alert.warning('Seleccione al menos una fecha', { effect: 'genie', position: 'bottom-right', timeout: 2000 });
			else {
				const snapPrograDia = await firebase.database().ref().child('ProgramacionDia').orderByChild('programacion').equalTo(prograID.id).once('value');
				const dataPrograDia = snapPrograDia.val();
				const prograDia = [];
				for (const key in dataPrograDia) {
					dataPrograDia[key].key = key;
					prograDia.push(dataPrograDia[key]);
				}


				const modifPrograDia = prograDia.filter((item, i) => {
					return fechasString.includes(moment(item.fecha).format());
				})

				const colaProgramacionDia = [];
				for (const item of modifPrograDia) {

					const hours = moment(prograID.start).hours();
					const minutes = moment(prograID.start).minutes();

					let newFecha = new Date(item.fecha).setHours(hours);
					newFecha = new Date(newFecha).setMinutes(minutes);
					newFecha = new Date(newFecha).toString();

					await firebase.database().ref().child('ProgramacionDia').child(item.key).update({ vehiculo, conductor });

					colaProgramacionDia.push({ programacionDia: item.key, fecha: newFecha });
				}

				const minDate = moment.min(fechasString.map(val => moment(val))).format();
				const firstDate = modifPrograDia.find(val => moment(val.fecha).format() == minDate);

				await firebase.database().ref().child('Programacion').child(prograID.id).child('colaProgramacionDia').push({ vehiculo, conductor, programacionDias: colaProgramacionDia });

				const snapEmpleado = await firebase.database().ref('/Empleados').child(conductor).once('value');
				const empleado = snapEmpleado.val();

				let cola = [];
				if (empleado.colaProgramacionDia)
					cola = empleado.colaProgramacionDia

				cola = [...cola, ...colaProgramacionDia];

				const snapVehiculo = await firebase.database().ref('/Vehiculos').child(vehiculo).once('value');
				const dataVehiculo = snapVehiculo.val();

				if (!dataVehiculo.viajeAsignado)
					firebase.database().ref().child('Vehiculos').child(vehiculo).update({ viajeAsignado: firstDate.key });

				if (empleado.viajeAsignado)
					firebase.database().ref().child('Empleados').child(conductor).update({ vehiculo, colaProgramacionDia: cola });
				else
					firebase.database().ref().child('Empleados').child(conductor).update({ vehiculo, colaProgramacionDia: cola, viajeAsignado: firstDate.key });

				this.asignarCoductorVehiculo(); 	//actualiza el modal

				sendLog({ tipo: 'programacion_cola_nuevo', informacion_extra: {conductor: this.state.conductor, vehiculo: this.state.vehiculo, programacionDia: colaProgramacionDia.map(el=>el.programacionDia) } });
			}
		} catch (error) {
			console.log('error en guardarAsignacionVehiculo:', error);
		}

	}

	isELi() {
		this.setState({ isElimi: !this.state.isElimi, isGuar: false })
	}

	replanificar = () => {
		let { prograID, rutas, centroCosto, flota, empresaUID } = this.state;
		firebase.database().ref('Programacion/' + prograID.id).once('value').then(snap => {
			let seleccionados = [];
			let guardados = [];
			let obejetos = snap.val();
			if (obejetos !== undefined) {
				obejetos.frecuencia.forEach(element => {
					seleccionados.push(element);
					guardados.push(element)
				});
				let vuelo = obejetos.vuelo;
				let rutaA = rutas.find(x => obejetos.ruta === x.value);
				let centro = centroCosto.find(x => obejetos.centroC === x.value);
				let time = obejetos.horaReco.split(':');
				let time2 = obejetos.horaAero.split(':');
				let now = moment().hour(Number(time[0])).minute(Number(time[1]))
				let now2 = moment().hour(Number(time2[0])).minute(Number(time2[1]))
				let value = obejetos.tipo;
				let hour = Number(time[0])
				let minute = Number(time[1])
				let hour2 = Number(time2[0])
				let minute2 = Number(time2[1])
				let flotaD = obejetos.flota;
				let entrenamiento = obejetos.entrenamiento;

				if (value === 'pilotossap' || value === 'tcssap') {

					this.setState({ select: true });
					firebase.database().ref('Flotas/' + flotaD).once('value').then(data => {
						let element = data.val();
						if (element !== null && element !== undefined) {
							this.setState({ flota: { label: element.flota, value: flotaD } });
						}

					})

				}
				else {
					this.setState({ select: false });
					this.selectValidate();

				}
				seleccionadosGuardados = seleccionados;
				this.setState({
					seleccionados, isActiveSeleccion: false, isActive: true, vuelo,
					rutaA, now, now2, guardados, centro, value, hour, minute, hour2, minute2, entrenamiento
				})
			}

		})

	}


	justi = (data) => {
		this.setState({ justiCanc: data.target.value });
	}
	justiA = (data) => {
		this.setState({ justiAdd: data.target.value });
	}

	cancela = () => {
		let { seleElim, justiCanc, prograDiaId, pasajerosArr, viajesD } = this.state;
		let pasajeros = [];
		if (pasajerosArr.length === 0) {
			Alert.warning('Seleccione un empleado al cual cancelar el viaje', { effect: 'genie', position: 'bottom-right', timeout: 2000 });
		}
		else {
			if (justiCanc === '') {
				Alert.warning('Favor ingresar el motivo por el cual se esta cancelando el viaje', { effect: 'genie', position: 'bottom-right', timeout: 2000 });
			}
			else {
				firebase.database().ref('ProgramacionDia').child(prograDiaId).once('value').then(snap => {
					viajesD.forEach(element => {

						let findviajesD = pasajerosArr.find(vfind => {
							return vfind.codigo === element.codigo
						})
						if (findviajesD === undefined) {
							pasajeros.push(element);
						}

					})
					firebase.database().ref().child('ProgramacionDia/' + prograDiaId).update({
						pasajeros,
						motiRetiro: justiCanc
					})
					this.setState({ viajesD: pasajeros })
					Alert.success('Los pasajeros fueron eliminados con éxito', {
						effect: 'genie',
						position: 'bottom-right',
						timeout: 2000
					});
				})
				this.setState({ justiCanc: '', isElimi: false })
				sendLog({ tipo: 'pasajero_eliminado', informacion_extra: {pasajero: viajesD.map(el=>el.codigo), programacionDia: prograDiaId} });
			}
		}
	}

	marcar = (seleElim, index) => {

		let { pasajerosArr } = this.state;
		if (document.getElementById(index).classList.contains('selecccion')) {
			document.getElementById(index).classList.toggle('selecccion');
			document.getElementById(index).classList.add('normalEm');

			this.state.pasajerosArr.forEach(element => {

				if (element.codigo === seleElim.codigo) {

					let index = this.state.pasajerosArr.indexOf(seleElim);
					pasajerosArr.splice(index, 1);
					this.setState({ pasajerosArr })
				}

			})
			// this.EliminarP(seleElim);
		}
		else {

			document.getElementById(index).classList.toggle('normalEm');
			document.getElementById(index).classList.add('selecccion');
			// this.EliminarP(seleElim);
			if (pasajerosArr.length > 0) {

				pasajerosArr.forEach(element => {
					if (element.codigo !== seleElim.codigo) {
						this.setState({ pasajerosArr: [...this.state.pasajerosArr, seleElim] })
					}
				})
			} else {
				this.setState({ pasajerosArr: [...this.state.pasajerosArr, seleElim] })
			}

		}

	}

	nuevoPas() {
		this.setState({ isGuar: !this.state.isGuar, isElimi: false })
	}

	addEmple = () => {
		let { justiAdd, empleS, prograDiaId, viajesD, empresaUID } = this.state;
		if (justiAdd !== '') {
			if (empleS !== '') {
				let pasajeros = [];
				empleS.forEach(elementE => {
					let pasa = {
						codigo: elementE.value,
						horaLlegada: '',
						horaSubida: '',
						horaTimbre: '',
						nombre: elementE.label,
						subio: false,
						centroCosto: elementE.centroCosto,
						escalafon: elementE.escalafon,
						numero_empleado: elementE.codigo,
						areaU: elementE.areaUsuaria,
						coordenadas: elementE.coordenadas.coordenadas
					};
					pasajeros.push(pasa)
					viajesD.splice(viajesD.length, 0, pasa);
					console.log('Pasajeros ', pasajeros)
					firebase.database().ref('Clientes').child(elementE.value).once('value').then(snap => {
						let s = snap.val();
						let viajes = s.Viajes;
						if (s.Viajes !== undefined && s.Viajes !== '') {
							firebase.database().ref('Clientes').child(elementE.value).update({ Viajes: [...viajes, prograDiaId] });
						} else {
							firebase.database().ref('Clientes').child(elementE.value).update({ Viajes: [prograDiaId] });
						}
					});
				});
				if (viajesD.length === 0) {
					firebase.database().ref().child('ProgramacionDia/' + prograDiaId).update({
						pasajeros, pilotos: true
					})
				} else {
					firebase.database().ref().child('ProgramacionDia/' + prograDiaId).update({
						pasajeros: viajesD, pilotos: true
					})
				}
				Alert.success('Su procesos ha sido realizado', {
					effect: 'genie',
					position: 'bottom-right',
					timeout: 1000
				});
				this.setState({ isGuar: false })
				sendLog({ tipo: 'pasajero_nuevo', informacion_extra: {pasajero: viajesD.map(el=>el.codigo), programacionDia: prograDiaId } });
			}
			else {
				Alert.warning('Seleccione un empleado a añadir', { effect: 'genie', position: 'bottom-right', timeout: 2000 });
			}
		}
		else {
			Alert.warning('Favor ingresar el motivo por el cual se esta añadiendo el pasajero', { effect: 'genie', position: 'bottom-right', timeout: 2000 });
		}
	}

	addEmpleS = (event) => {
		this.setState({ empleS: event })
	}

	onTimeChange(options) {
		let hora = moment(options, "hmm").format("HH:mm")
		let data = hora.split(':');
		this.setState({ hour: data[0], minute: data[1], now: options.format('HH:mm:ss') });
	}

	onTimeChange2(options) {
		let hora = moment(options, "hmm").format("HH:mm")
		let data = hora.split(':');
		this.setState({ hour2: data[0], minute2: data[1], now2: options.format('HH:mm:ss') });
	}

	selectRuta(rutaA) {
		this.setState({ rutaA });
	}
	selectCentro(centro) {
		this.setState({ centro });
	}

	selectFlota(flota) {
		this.setState({ flota });
	}

	componentDidMount() {
		const ref = firebase.firestore().collection('TiposViajes').doc(this.props.match.params.id);
		ref.get().then((doc) => {
			if (doc.exists) {
				this.setState({
					board: doc.data(),
					key: doc.id,
					isLoading: false
				});
			} else {
				console.log("Error!");
			}
		});
	}


	handleSelect = async (evt) => {
		const { value, name } = evt.target;
		// const {prograID} = this.state;


		// if(name=='conductor'){
		// 	let isOk =true;
		// 	if(value){
		// 		console.log('value :', value);
		// 		const snapConductor = await firebase.database().ref().child('Empleados').child(value).once('value');
		// 		const conductor = snapConductor.val();
		// 		console.log('conductor :', conductor);
		// 		if(conductor.colaProgramacionDia && conductor.colaProgramacionDia.length){
		// 			const snapProgra   = await firebase.database().ref().child('ProgramacionDia').orderByChild('programacion').equalTo(prograID.id).limitToFirst(1).once('value');
		// 			const dataProgramacion = snapProgra.val(); 
		// 			let programacion = {};
		// 			for (const key in dataProgramacion) {
		// 				programacion = dataProgramacion[key];
		// 				break;
		// 			}
		// 			console.log('programacion :', programacion);

		// 			for (const item of conductor.colaProgramacionDia) {

		// 				const snapPrograDia = await firebase.database().ref().child('ProgramacionDia').child(item.programacionDia).once('value');
		// 				const prograDia     = await snapPrograDia.val();

		// 				if(prograDia){
		// 					const fechaSeleccionada = moment(programacion.fecha).format('YYYY/MM/DD');
		// 					const fechaProgramada = moment(prograDia.fecha).format('YYYY/MM/DD');

		// 					if(fechaSeleccionada==fechaProgramada){	//fecha seleccionada es la misma a alguna programada
		// 						const horaSeleccionadaString = programacion.horaInicio.split(':');
		// 						const horaSeleccionada       = horaSeleccionadaString[0];
		// 						const minutoSeleccionado     = horaSeleccionadaString[1];

		// 						const horaProgramadaString = prograDia.horaInicio.split(':');
		// 						const horaProgramada       = horaProgramadaString[0];
		// 						const minutoProgramado     = horaProgramadaString[1];

		// 						if(horaSeleccionada==horaProgramada){ 	//es a la misma hora 
		// 							if(minutoSeleccionado <= minutoProgramado){	//es durante el viaje programado
		// 								Alert.warning('El conductor seleccionado ya tiene un viaje asignado', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
		// 								isOk=false;
		// 							}
		// 						}
		// 					}
		// 				}
		// 			}
		// 		}
		// 		if(isOk)
		// 			this.setState({ [name]: value });
		// 	}
		// }else{
		this.setState({ [name]: value });
		// }

	}

	render() {
		let { viaje, tiposViajes, filtro, eventos, seleccionados, actualV, generales, isGuar, empleadosEmpresa, estado, edt2, rutaA, rutas, now, now2,
			isLoading, centroCosto, centro, flotas, flota, select, entrenamiento, empresa, empresas, empresaUID, isActiveSeleccion,
			isActiveModificar, isActive, isSaving, isModalOpen } = this.state;
		if (isLoading !== true) {
			return (
				<div onClick={this.ocultarMenu}>
					<div className="container">
						<div className="row justify-content-sm-end">
							<div className="col-sm-1 align-self-end">
								<label>Empresa:</label>
							</div>
							<div className="col-sm-4">
								<Select value={empresa} className="Select-menu-outer" onChange={this.changeEmpresa} placeholder="Seleccione una empresa" options={empresas}></Select>
							</div>
						</div>
					</div>
					<div style={{ height: 600, margin: 30 }}>
						{this.state.template ? <Alert timeout='none' stack={{ limit: 1 }} contentTemplate={this.AlertaContenido} /> : <Alert stack={{ limit: 1 }} html={true} />}
						<BigCalendar
							selectable events={(isActiveSeleccion === false && isActiveModificar === false && isActive === false)
								? eventos
								: []
							} popup culture={'es'}
							defaultDate={new Date()} onSelectEvent={this.validar}
							onSelectSlot={this.nuevaRese}
							eventPropGetter={this.tipo}
							messages={{ 'today': "Hoy", "previous": 'Anterior', "next": "Siguiente", "month": "Mes", "week": "Semana", "day": "Dia", "agenda": "Agenda" }}
						/>
						<div className="row" >
							<div className="col-sm-12">
								<div className="row">
									{this.state.viajes ? (this.state.viajes.map(snap => {
										return (
											<div className="col-sm-3 bordeInte borde">
												<div className="row">
													<div className="col-sm-11 margenI cuadro" style={{ backgroundColor: snap.color }}></div>
													<div className="col-sm-11 bordeInte2"><span style={{ textAlign: 'justify' }}>{snap.data}</span></div>
												</div>
											</div>
										)
									})) : (false)
									}
								</div>
							</div>
							<div className="col-sm-9"></div>
						</div>
						<Modal isOpen={isModalOpen} onRequestClose={() => { this.setState({ isModalOpen: false }) }} style={customStyles}>
							<div className='row'>
								<div className="col-md-5">
									<InfiniteCalendar width={"100%"} height={300}
										locale={{
											locale: require('date-fns/locale/es'), headerFormat: 'dddd, D MMM',
											weekdays: ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"],
											blank: 'Nada seleccionado', todayLabel: { long: 'Ahora', short: 'Ahora' }
										}}
										Component={withMultipleDates(Calendar)} selected={seleccionados}
										disabledDates={this.state.disabledDays}
										interpolateSelection={defaultMultipleDateInterpolation} onSelect={this.selecion}
										tabIndex={4} minDate={this.state.minDate} maxDate={this.state.maxDate} />
								</div>
								<div className='col-md-7'>
									<div className='row'>
										<div className="form-group col-md-6">
											<label className="label-bold" htmlFor="tipo"><img src={driverSVG} /> Asignar Conductor</label>
											<select name="conductor" className="form-control" onChange={this.handleSelect} value={this.state.conductor}>
												<option value=''>Seleccion un conductor</option>
												{this.state.filteredConductores.map((item, i) => <option key={item.key} value={item.key}>{item.nombre}</option>)}
											</select>
										</div>
										<div className="form-group col-md-6">
											<label className="label-bold" htmlFor="tipo"><img src={vehiculoSVG} /> Asignar Vehículo</label>
											<select name="vehiculo" className="form-control" onChange={this.handleSelect} value={this.state.vehiculo}>
												<option value=''>Seleccion un vehiculo</option>
												{this.state.vehiculos.map((item, i) => <option key={item.key} value={item.key}>{`${item.movil} (${item.placa})`}</option>)}
											</select>
										</div>
										<div className="form-group col-md-6">
											<input type='text' disabled='true' className="form-control" placeholder='Fecha Inicio' value={this.state.fechaInicio} />
										</div>
										<div className="form-group col-md-6">
											<input type='text' disabled='true' className="form-control" placeholder='Fecha Fin' value={this.state.fechaFin} />
										</div>
										<div className='col-md-12 text-center'>
											<button type="button" className="btn btn-small-green" onClick={this.guardarAsignacionVehiculo} style={{ width: '40%' }}>Guardar</button>
										</div>
									</div>
									<div className='row'></div>
									<div className='row'>
										<table className="table">
											<thead>
												<tr>
													<th>Conductor</th>
													<th>Vehiculo</th>
													<th>Fecha Inicio</th>
													<th>Fecha Fin</th>
												</tr>
											</thead>
											<tbody>
												{this.state.colaProgramacionDia.map(item => {
													return (
														<tr>
															<td>{item.conductor}</td>
															<td>{item.vehiculo}</td>
															<td>{item.inicio}</td>
															<td>{item.fin}</td>
														</tr>
													)
												})}
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</Modal>


						<Modal isOpen={isActive} onRequestClose={this.toggleActive} style={customStyles}>
							{
								isSaving &&
								<Pulse />
							}
							{
								!isSaving &&
								<div className="row">
									<div className="col-12 col-md-5">
										<InfiniteCalendar width={"100%"} height={300}
											locale={{
												locale: require('date-fns/locale/es'), headerFormat: 'dddd, D MMM',
												weekdays: ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"],
												blank: 'Nada seleccionado', todayLabel: { long: 'Ahora', short: 'Ahora' }
											}}
											Component={withMultipleDates(Calendar)} selected={seleccionados}
											interpolateSelection={defaultMultipleDateInterpolation} onSelect={this.selecion}
											tabIndex={4} minDate={new Date()}
										/>
									</div>
									<div className="col-12 col-md-7">
										<h4 className="title-bold">Planificación de viajes</h4>
										<form method="POST" action="" onSubmit={this.guardarReserva} >
											<div className="form-group col-md-5">
												<div className="btn-group form-mar-top" role="group">
													<button type="button" className="btn btn-small-aqua">Viaje</button>
												</div>
											</div>
											<div className="form-row">
												<div className="form-group col-md-6">
													<label className="label-bold" htmlFor="Viaje" >Viaje</label>
													<input type="text" className="form-control" name="Viaje"
														ref={vuelo => { this.vuelo = vuelo; }}
														placeholder="No de Viaje"
														required
														onBlur={(e) => this.setState({ nombreViaje: e.target.value })}
														defaultValue={this.state.vuelo} />
												</div>
												<div className="form-group col-md-6">
													<label className="label-bold" htmlFor="tipo">Tipo</label>
													<select name="tipo" className="form-control" onChange={this.handleChangeE} value={this.state.value}>
														<option value="pilotos"> Pilotos en Operación</option>
														<option value="pilotossap">Pilotos en Academia</option>
														<option value="tcs"> Tripulantes de Cabina en Operación</option>
														<option value="tcssap">Tripulantes de Cabina en Academia</option>
														<option value="persTierr">Personal Tierra en Operación</option>
													</select>
												</div>
												{select &&
													<div style={{ width: '100%' }} className="form-row">
														<div className="form-group col-md-6">
															<label className="label-bold" htmlFor="tipo">Entrenamiento</label>
															<select name="entrenamiento" className="form-control" placeholder="Seleccione una Tipo Entrenamiento" onChange={this.handleChange} value={this.state.entrenamiento} defaultValue={entrenamiento}>
																<option value="inicial">Inicial</option>
																<option value="recurrente">Recurrente</option>
															</select>
														</div>
														<div className="form-group col-md-6">
															<label className="label-bold" htmlFor="flota">Flota</label>
															<Select value={flota} placeholder="Seleccione una Flota" onChange={(e) => this.selectFlota(e)} options={flotas} defaultValue={flota} />
														</div>
													</div>
												}
											</div>
											<div className="form-row">
												<div className="form-group col-md-6">
													<label className="label-bold">Hora requerida de recogida</label>
													<TimePicker
														showSecond={false}
														defaultValue={now}
														style={{ width: '100%' }}
														onChange={this.onTimeChange.bind(this)}
														use12Hours
														inputReadOnly />
												</div>
												<div className="form-group col-md-6">
													<label className="label-bold">Hora requerida de llegada.</label>
													<TimePicker
														showSecond={false}
														defaultValue={now2}
														style={{ width: '100%' }}
														onChange={this.onTimeChange2.bind(this)}
														use12Hours
														inputReadOnly />
												</div>
											</div>
											<div className="form-row">
												<div className="col-sm-12 col-md-6">
													<label className="label-bold" htmlFor="Viaje" >Tipos de Rutas</label>
													<Select placeholder='Seleccione la ruta' value={filtro} className="css-10nd86i-2" onChange={(e) => this.selectViaje(e)} options={viaje} defaultValue={filtro} />
												</div>
												<div className="col-sm-12 col-md-6">
													<label className="label-bold" htmlFor="Viaje" >Rutas</label>
													<Select placeholder='Seleccione la ruta' value={rutaA} className="css-10nd86i-2" onChange={(e) => this.selectRuta(e)} options={this.filterRutas()} defaultValue={rutaA} />
												</div>
												<div className="col-sm-12 col-md-6">
													<label className="label-bold" htmlFor="Viaje" style={{ marginTop: '15px' }}>Centro de costos</label>
													<Select placeholder='Seleccione la ruta' value={centro} className="css-10nd86i-2" onChange={(e) => this.selectCentro(e)} options={centroCosto} defaultValue={centro} />
												</div>
											</div>
											{/* {
											!this.state.isSaving && */}
											<div className="form-group col-md-4 ml-auto">
												<button type="submit" className="btn btn-green btn-mar-top float-right">Guardar</button>
											</div>

										</form>
									</div>
								</div>
							}
						</Modal>

						<Modal isOpen={isActiveSeleccion} onRequestClose={this.toggleActiveS} style={customStylesS}>
							<div className="row" style={{ height: '100%' }}>
								<div className="col-sm-4 centro2" style={{ height: '100%' }}>
									<div className="row">
										<div className="col-sm-12 centro2">
											<div className='iconoso'></div>
										</div>
										<div className="col-sm-12 ">
											<p className='nuevoTex' style={{ fontFamily: 'Fira Sans' }}>Planificación de viajes</p>
										</div>
										<div className="col-sm-12 centro2 ">
											<button onClick={() => this.replanificar()} type="button" className="btn btn-round" style={{ backgroundColor: '#D25A2B' }}>Modificar</button>
										</div>
									</div>
								</div>
								<div className="col-sm-4 centro2" style={{ height: '100%', borderLeftWidth: 1 }}>
									<div className="row">
										<div className="col-sm-12 centro2">
											<div className='iconoso2'></div>
										</div>
										<div className="col-sm-12 ">
											<p className='nuevoTex' style={{ fontFamily: 'Fira Sans' }}>Pasajeros</p>
										</div>
										<div className="col-sm-12 centro2 ">
											<button onClick={this.modificar} type="button" className="btn btn-round" style={{ backgroundColor: '#D25A2B' }}>Modificar</button>
										</div>
									</div>
								</div>
								<div className="col-sm-4 centro2" style={{ height: '100%', borderLeftWidth: 1 }}>
									<div className="row mt-4">
										<div className="col-sm-12 centro2">
											<img src={driverSVG} style={{ width: '5em' }} />
										</div>
										<div className="col-sm-12" style={{ paddingTop: '2.2rem' }}>
											<p className='nuevoTex' style={{ fontFamily: 'Fira Sans' }}>Asignar conductor y vehiculo</p>
										</div>
										<div className="col-sm-12 centro2 mt-0">
											<button onClick={this.asignarCoductorVehiculo} type="button" className="btn btn-round" style={{ backgroundColor: '#D25A2B' }}>Modificar</button>
										</div>
									</div>
								</div>
							</div>
						</Modal>

						<Modal isOpen={isActiveModificar} onRequestClose={this.toggleActiveM} style={customStylesM}>
							<div className="col-12">
								<div className="row">
									<img src={icon} width="17px" height="28px" />
									<div className="col">
										<h6 className="font-tex">{generales.fecha}</h6>
										<h6 className="text-color">Multi-viajeros</h6>
									</div>
									<div className="col">
										<button onClick={this.nuevoPas} className="btn btn-green-ligth float-right">+ Añadir pasajero</button>
									</div>
									<div className="col">
										{edt2.desc === 'tcs' && <button type="button" className="btn btn-green-ligth float-right">{actualV.vuelo}</button>}
										{edt2.desc === 'pilotos' && <button type="button" className="btn btn-lg-purpura float-right">{actualV.vuelo}</button>}
										{edt2.desc === 'pilotossap' && <button type="button" className="btn btn-sky-blue float-right">{actualV.vuelo}</button>}
										{edt2.desc === 'tcssap' && <button type="button" className="btn btn-sky-tsc float-right">{actualV.vuelo}</button>}

									</div>
								</div>
								<div className="row">
									<div className="col text-right">
										<p className="p-type">Hora de recogimiento: <b>{actualV.horaReco}</b></p>
										<p className="p-type">Estado: <b>{estado}</b></p>
									</div>
								</div>

							</div>
							<div className="row">
								<div className="col-12">
									<div className="col-sm-6 col-sm-6">
										<p className='nuevoTexRN tipoB'>¿Alguno de los pasajeros ya no abordará? <p className='alinea' onClick={this.isELi} style={{ cursor: 'pointer', color: '#42a5f5', fontFamily: 'lato' }}>Haz clic aquí.</p></p>
									</div>
									<div className="row">
										<div className="col-sm-6 col-md-6 alto">
											{this.state.viajesD.map((snap, index) => {
												return (
													<div id={index} className='empleI normalEm'>
														<div className="col-sm-9">
															<p>{snap.nombre}</p>
														</div>
														{this.state.isElimi &&
															<div className="col-sm-1">
																<a onClick={() => this.marcar(snap, index)} href="#" className=" badge badge-danger">X</a>
															</div>
														}

													</div>
												)
											})}
										</div>
										<div className="col-sm-6 col-sm-6">
											<div className="col-sm-12">
												{isGuar &&
													<Select placeholder='Seleccione empleados' onChange={this.addEmpleS} isMulti options={empleadosEmpresa} />
												}
											</div>
										</div>
									</div>
								</div>
							</div>
							{this.state.isElimi &&
								<div style={{ marginTop: 10 }} className="row">
									<div className="col-12">
										<div className="row">
											<div className="col-12 col-md-7">
												<textarea onChange={this.justi} className="form-control form-control-bg"></textarea>
											</div>
											<div className="col-12 col-md-5">
												<button onClick={this.cancela} className="btn btn-sky-blue">Continuar</button>
											</div>
										</div>
									</div>
								</div>
							}
							{this.state.isGuar &&
								<div style={{ marginTop: 10 }} className="row">
									<div className="col-12">
										<div className="row">
											<div className="col-12 col-md-7">
												<textarea onChange={this.justiA} className="form-control form-control-bg"></textarea>
											</div>
											<div className="col-12 col-md-5">
												<button onClick={this.addEmple} className="btn btn-sky-blue">Continuar</button>
											</div>
										</div>
									</div>
								</div>
							}

						</Modal>
					</div>
					<br></br>
					<br></br>
					<footer className="footer-pg mt-auto py-3" style={{ width: '100%' }}>
						<div className="container">
							<div className="row">
								<div className="col-md-4 col-sm-4">
								</div>
								<div className="col-sm">
									<img src={copyright} />
								</div>
							</div>
						</div>
					</footer>
				</div>
			)
		}
		else {
			return (
				<Pulse />
			)
		}
	}

}
export default NuevoViaje;


// WEBPACK FOOTER //
// ./src/Components/Programacion/nuevoViajeA.js